import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import ReactGA from 'react-ga4';
import './ourBalance.scss';

import { blue010, blue500, gray010, gray900 } from "../../uiKit/assets/colors/colors";
import Title from "../../uiKit/Title/Title";
import Balance from "../../components/Balance/balance";
import { OUR_BALANCE_DESCRIPTION, OUR_BALANCE_DESCRIPTION_NOTE } from "../../helpers/constants";
import RecentTransfersTable from "./RecentTransfers/recentTransfersTable";
import RecentDonationsTable from "./RecentDonations/recentDonationsTable"
import BalanceAccordion from "./balanceAccordion";
import { OurBalanceComponents } from "../../helpers/AppHelpers/components";

const OurBalance = () => {

    const [isActive, setIsActive] = useState(true);

    const communityBalance = useSelector(state => state.community.community.ourBalance, shallowEqual);
    const communityName = useSelector(state => state.community.community.name, shallowEqual);
    const isAdmin = useSelector(state => state.community.community.role, shallowEqual);
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);
    const isMobile = screenWidth < 900

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: `/our-balance` })
    }, [])

    return (
        <div>
            <div style={{
                padding: "32px",
                backgroundColor: gray010,
                boxShadow: "0px 4px 10px rgba(224, 238, 242, 0.8)",
                borderRadius: "12px",
            }}>
                <Balance balance={`$ ${communityBalance?.toLocaleString() ?? 0}`} title={communityName} />
                <div className='ourBalanceDescription'>
                    <Title
                        text={OUR_BALANCE_DESCRIPTION}
                        fontWeight={400}
                    />
                    <Title
                        text={OUR_BALANCE_DESCRIPTION_NOTE}
                        fontWeight={400}
                    />
                </div>
                <OurBalanceComponents.Amount />
            </div>
            <div>
                {
                    !!isAdmin ? (
                        <div className='campaignButton'>
                            <Title
                                text="Recent Donations"
                                fontSize={16}
                                lineHeight={20}
                                fontWeight={600}
                                color={isActive ? blue500 : gray900}
                                onClick={() => setIsActive(true)}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: isActive ? gray010 : blue010,
                                    borderRadius: '8px',
                                }}
                            />
                            <Title
                                text="Recent Transfers"
                                fontSize={16}
                                lineHeight={20}
                                fontWeight={600}
                                color={!isActive ? blue500 : gray900}
                                onClick={() => setIsActive(false)}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: !isActive ? gray010 : blue010,
                                    borderRadius: '8px',
                                }}
                            />
                        </div>
                    ) : (
                        <div className='campaignButton'>
                            <div className='userActiveCampaigns'>
                                Recent Donations
                            </div>
                        </div>
                    )
                }
                {isActive && !isMobile && <RecentDonationsTable />}
                {!!isAdmin && !isActive && !isMobile && <RecentTransfersTable />}
                {isMobile && <BalanceAccordion />}
            </div>
        </div>
    )
}

export default OurBalance;